(function () {
  'use strict';

  /* @ngdoc object
   * @name renewals
   * @description
   *
   */
  angular
    .module('renewals', [
      'ui.router'
    ]);
}());
